import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, CardHeader, CardBody } from '../Card'
import actions from '../../actions/index'
import Loader from 'react-loader-spinner'
import Collapsible from '../Collapsible'

class PortfolioPaddle extends Component {
  constructor (props) {
    super(props)
    this.collapsible = React.createRef()
  }

  componentDidMount () {
    var ids = this.props.alertPreference.portfolios.join()
    this.props.onSearch(ids)
  }

  render () {
    const ShowPortfolioTitle = ({ apiData }) => (
      <>
        {apiData.documents
          .map(portfolio => (
            <span key={portfolio.contentId} className='portfolio'>
              <a className='hyperLink' rel='noopener noreferrer' href={`/#/content/${portfolio.contentId}?referrer=portfolio_linkclick`}>{portfolio.title}</a>
            </span>
          ))}
      </>
    )

    return (
      <div id='portfolio_paddle' className={'paddle portfolio_paddle' + (this.props.alertPreference.portfolios.length > 0 ? ' alert_enabled' : ' alert_disabled')}>
        <Card>
          <Collapsible ref={this.collapsible} title={this.props.name} titleClassName='paddle_name' open={this.props.alertPreference.portfolios.length == 0}>
            <CardBody>
              <div className='card_body_row'>
                <div>
                  <span className='category_text'>
                    When a new article is published for a Portfolio that you follow, receive one email containing the full text of the article the moment it is published.
                    Use the toggle at the top of the Portfolio page to switch alerts on or off.
                    Once alerts are switched off for a Portfolio, the title will no longer be listed here.
                  </span>
                </div>
              </div>
              {
                this.props.alertPreference.portfolios.length > 0 &&
                    <div className='card_body_row'>
                      <div className='portfolio_items_wrapper'>
                        <div className='portfolio_alerts'>
                          {
                            this.props.search.fetching === false
                              ? (
                                this.props.search.error === ''
                                  ? (
                                    this.props.search.searchResult.hasError === true
                                      ? (
                                        <div className='error'>Sorry, an error has occurred and we are unable to load the Portfolio titles.<br />
                                    Please refresh your browser to try again. If the error persists, please contact Customer Services for assistance.
                                        </div>
                                      )
                                      : (
                                        this.props.search.searchResult.documents
                                          ? <ShowPortfolioTitle apiData={this.props.search.searchResult} />
                                          : <Loader type='ThreeDots' color='#A8171F' height={40} width={40} />
                                      )
                                  )
                                  : <div className='error'>Sorry, an error has occurred and we are unable to load the Portfolio titles.<br />
                                Please refresh your browser to try again. If the error persists, please contact Customer Services for assistance.
                                  </div>
                              )
                              : <Loader type='ThreeDots' color='#A8171F' height={40} width={40} />
                          }
                        </div>
                      </div>
                    </div>
              }
            </CardBody>
          </Collapsible>
        </Card>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    search: state.search
  }
}

const mapDispatchToProps = (dispatch) => ({
  onSearch (ids) {
    dispatch(actions.searchContent('', ids))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PortfolioPaddle)
